//Vuex
import Vue from 'vue'

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    'en': {    
      'home': 'Home',
      'projects': 'Projects',
      'media': 'Media',
      'notebook': 'Notebook',
      'todo': 'Todo',
      'loans': 'Loans',
      'section': 'Section',
      'order': 'Order',
      'profile': 'Profile',
      'user': 'User',
      'role': 'Role',
      'FinLoan': 'Loans',
      'logout': 'Logout',
      'contactPerson': 'Contact List',
      'chat': 'Chat',
      'herrmann': 'Herrmann',
      'project': 'Projects',
      'AnakateyProducts': 'Anakatey Products',
      'WebSite': 'Website',
      'socailmediaAccount': 'Social Media Accounts',
      'socailmediaPost': 'Social Media Posts',
      'socailmediaTemplate': 'Social Media Templates',
      'app': {
        'order': {
          'Unknowen': 'Unknowen',
          'Delete': 'DELETE',
          'Done': 'Done',
          'Copy': 'COPY',
          'Need': 'Need',
          'Require': 'Require',
          'Urgent': 'Urgent',
          'DoneBy': 'Done By',
          'N': 'Yes',
          'Y': 'No',
          'Title': 'Title',
          'Description': 'Description',
          'Sections': 'Sections',
          'Save': 'Save',
          'Orders': 'Orders',
          'NewOrder': 'New Order',
          'cost': 'Cost',
        },
        'project': {
          'notes': 'Notes',
          'tasks': 'Tasks',
          'reminders': 'Reminders',
          'files': 'Files',
          'accounting': 'Accounting',
          'crm': 'CRM',
          'hr': 'HR',
          'accounts': 'Accounts',
          'entries': 'Entries',
          'reports': 'Reports',
          'periods': {
            'today': 'Today',
            'thisWeek': 'This Week',
            'thisMonth': 'This Month',
            'yesterday': 'Yesterday',
            'lastWeek': 'Last Week',
            'lastMonth': 'Last Month',
          },
          'accountingTabs': {
            'dashboard': 'Dashboard',
            'balanceSheet': 'Balance Sheet',
            'profitLoss': 'P/L Statement',
            'cashFlow': 'Cash Flow Statement',
            'accountReports': 'Account Reports',
            'liabilitiesEquity': 'Liabilities & Equity',
            'netProfit': 'Net Profit',
            'netAssets': 'Net Assets',
            'cashMovement': 'Cash Movement',
            'cashIn': 'Cash In',
            'cashOut': 'Cash Out',
            'netCashFlow': 'Net Cash Flow',
            'operatingActivities': 'Operating Activities',
            'investingActivities': 'Investing Activities',
            'financingActivities': 'Financing Activities',
            'status': 'Status',
            'draft': 'Draft',
            'posted': 'Posted',
            'reversed': 'Reversed',
          },
          'name': 'Name',
          'type': 'Type',
          'description': 'Description',
          'debit': 'Debit',
          'credit': 'Credit',
          'amount': 'Amount',
          'date': 'Date',
          'balance': 'Balance',
          'total': 'Total',
          'refresh': 'Refresh',
          'save': 'Save',
          'createDefaults': 'Create Default Accounts',
          'confirmDelete': 'Do you really want to delete this?',
          'phone': 'Phone',
          'email': 'Email',
          'company': 'Company',
          'logs': 'Logs',
          'newLog': 'New Log',
          'position': 'Position',
          'salary': 'Salary',
          'types': {
            'asset': 'Asset',
            'liability': 'Liability',
            'equity': 'Equity',
            'revenue': 'Revenue',
            'expense': 'Expense',
          },
          'carousel': {
            'title': 'Carousel',
            'newCarousel': 'New Carousel',
            'carouselTitle': 'Carousel Title',
            'themeColor': 'Theme Color',
            'accentColor': 'Accent Color',
            'font': 'Font',
            'backgroundStyle': 'Background Style',
            'solid': 'Solid',
            'gradient': 'Gradient',
            'radial': 'Radial',
            'logo': 'Logo',
            'uploadLogo': 'Upload Logo',
            'theme': 'Theme',
            'slides': 'Slides',
            'addSlide': 'Add Slide',
            'slideTitle': 'Title',
            'subtitle': 'Subtitle',
            'mainText': 'Main Text',
            'highlights': 'Highlights',
            'addHighlight': 'Add Highlight',
            'icon': 'Icon (emoji)',
            'image': 'Slide Image',
            'uploadImage': 'Upload Image',
            'slideOf': 'Slide {current} / {total}',
            'previous': 'Previous',
            'next': 'Next',
            'downloadPng': 'Download PNG',
            'downloadJpg': 'Download JPG',
            'downloadAll': 'Download All',
            'noSlides': 'No slides yet. Add your first slide.',
            'confirmDeleteSlide': 'Delete this slide?',
            'confirmDeleteCarousel': 'Delete this carousel and all its slides?',
            'importJson': 'Import from JSON (AI)',
            'importHint': 'Paste the JSON generated by the AI here...',
            'importBtn': 'Import',
            'importInvalid': 'Invalid JSON.',
            'importNoSlides': 'No "slides" array found in the JSON.',
            'importFailed': 'Import failed. Please try again.',
          },
          'brand': {
            'title': 'Brand',
            'intro': 'Set your colors, font and logo once. Every new carousel uses them automatically.',
            'footer': 'Footer (account name & contact)',
            'footerHint': 'e.g. @my.account\\nwww.mysite.com',
          }
        }
      }
    },
    'ar': {
      'home': 'الرئيسية',
      'projects': 'المشاريع',
      'media': 'مشغل الفديو',
      'notebook': 'المفكرة',
      'todo': 'المهام',
      'loans': 'الديون',
      'section': 'أقسام المنزل',
      'order': 'طلبات المنزل',
      'profile': 'البيانات الشخصية',
      'user': 'المستخدمين',
      'role': 'الصلاحيات',
      'FinLoan': 'الديون الشخصية',
      'logout': 'تسجيل خروج',
      'contactPerson': 'قائمة الأتصالات',
      'chat': 'الدردشة',
      'herrmann': 'هيرمان',
      'project': 'المشاريع',
      'AnakateyProducts': 'منتجات عناقتي',
      'WebSite': 'المواقع',
      'socailmediaAccount': 'حسابات التواصل الاجتماعي',
      'socailmediaPost': 'منشورات التواصل الاجتماعي',
      'socailmediaTemplate': 'قوالب التواصل الاجتماعي',
      'app': {
        'order': {
          'Unknowen': 'غير معلوم',
          'Delete': 'حذف',
          'Done': 'تم',
          'Copy': 'نسخ',
          'Need': 'إحتياج',
          'Require': 'مطلوب',
          'Urgent': 'عاجل',
          'DoneBy': 'المنجز',
          'N': 'نعم',
          'Y': 'لا',
          'Title': 'العنوان',
          'Description': 'الوصف',
          'Sections': 'القسم',
          'Save': 'حفظ',
          'Orders': 'الطلبات',
          'NewOrder': 'طلب جديد',
          'cost': 'التكلفة',
        },
        'project': {
          'notes': 'الملاحظات',
          'tasks': 'المهام',
          'reminders': 'التذكيرات',
          'files': 'الملفات',
          'accounting': 'المحاسبة',
          'crm': 'إدارة العملاء',
          'hr': 'الموارد البشرية',
          'accounts': 'الحسابات',
          'entries': 'القيود',
          'reports': 'التقارير',
          'periods': {
            'today': 'اليوم',
            'thisWeek': 'هذا الأسبوع',
            'thisMonth': 'هذا الشهر',
            'yesterday': 'أمس',
            'lastWeek': 'الأسبوع الماضي',
            'lastMonth': 'الشهر الماضي',
          },
          'accountingTabs': {
            'dashboard': 'لوحة المؤشرات',
            'balanceSheet': 'الميزانية العمومية',
            'profitLoss': 'قائمة الربح والخسارة',
            'cashFlow': 'قائمة التدفقات النقدية',
            'accountReports': 'تقارير الحسابات',
            'liabilitiesEquity': 'الخصوم وحقوق الملكية',
            'netProfit': 'صافي الربح',
            'netAssets': 'صافي الأصول',
            'cashMovement': 'حركة النقد',
            'cashIn': 'نقد داخل',
            'cashOut': 'نقد خارج',
            'netCashFlow': 'صافي التدفق النقدي',
            'operatingActivities': 'أنشطة تشغيلية',
            'investingActivities': 'أنشطة استثمارية',
            'financingActivities': 'أنشطة تمويلية',
            'status': 'الحالة',
            'draft': 'مسودة',
            'posted': 'مُرحل',
            'reversed': 'معكوس',
          },
          'name': 'الاسم',
          'type': 'النوع',
          'description': 'الوصف',
          'debit': 'مدين',
          'credit': 'دائن',
          'amount': 'المبلغ',
          'date': 'التاريخ',
          'balance': 'الرصيد',
          'total': 'الإجمالي',
          'refresh': 'تحديث',
          'save': 'حفظ',
          'createDefaults': 'إنشاء الحسابات الأساسية',
          'confirmDelete': 'هل تريد حقاً حذف هذا؟',
          'phone': 'الهاتف',
          'email': 'البريد الإلكتروني',
          'company': 'الشركة',
          'logs': 'السجلات',
          'newLog': 'سجل جديد',
          'position': 'المنصب',
          'salary': 'الراتب',
          'types': {
            'asset': 'أصول',
            'liability': 'خصوم',
            'equity': 'حقوق ملكية',
            'revenue': 'إيرادات',
            'expense': 'مصروفات',
          },
          'carousel': {
            'title': 'كاروسيل انستقرام',
            'newCarousel': 'كاروسيل جديد',
            'carouselTitle': 'عنوان الكاروسيل',
            'themeColor': 'لون الخلفية',
            'accentColor': 'اللون المميز',
            'font': 'الخط',
            'backgroundStyle': 'نمط الخلفية',
            'solid': 'ثابت',
            'gradient': 'متدرج',
            'radial': 'دائري',
            'logo': 'الشعار',
            'uploadLogo': 'رفع الشعار',
            'theme': 'التصميم',
            'slides': 'الشرائح',
            'addSlide': 'إضافة شريحة',
            'slideTitle': 'العنوان',
            'subtitle': 'العنوان الفرعي',
            'mainText': 'النص الرئيسي',
            'highlights': 'نقاط مميزة',
            'addHighlight': 'إضافة نقطة',
            'icon': 'أيقونة (رمز تعبيري)',
            'image': 'صورة الشريحة',
            'uploadImage': 'رفع صورة',
            'slideOf': 'شريحة {current} / {total}',
            'previous': 'السابق',
            'next': 'التالي',
            'downloadPng': 'تحميل PNG',
            'downloadJpg': 'تحميل JPG',
            'downloadAll': 'تحميل الكل',
            'noSlides': 'لا توجد شرائح بعد. أضف أول شريحة.',
            'confirmDeleteSlide': 'حذف هذه الشريحة؟',
            'confirmDeleteCarousel': 'حذف هذا الكاروسيل وجميع شرائحه؟',
            'importJson': 'استيراد من JSON (ذكاء اصطناعي)',
            'importHint': 'الصق هنا كود JSON الذي أنشأه الذكاء الاصطناعي...',
            'importBtn': 'استيراد',
            'importInvalid': 'صيغة JSON غير صحيحة.',
            'importNoSlides': 'لا توجد مصفوفة "slides" في الكود.',
            'importFailed': 'فشل الاستيراد. حاول مرة أخرى.',
          },
          'brand': {
            'title': 'الهوية',
            'intro': 'حدّد الألوان والخط والشعار مرة واحدة. كل كاروسيل جديد سيستخدمها تلقائياً.',
            'footer': 'التذييل (اسم الحساب وطريقة التواصل)',
            'footerHint': 'مثال: @حسابي\\nwww.mysite.com',
          }
        }
      }
    },
  }
})
//{{ $t('app.order.
// :label="$t('app.order.Urgent')" 
export default i18n
